import { render } from "./SnapshotList.vue?vue&type=template&id=216a931c"
import script from "./SnapshotList.vue?vue&type=script&lang=js"
export * from "./SnapshotList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__